import { render, staticRenderFns } from "./DisplayEditRecordForm.vue?vue&type=template&id=8cf487e0"
import script from "./DisplayEditRecordForm.vue?vue&type=script&lang=js"
export * from "./DisplayEditRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports